<template>
  <div
      class="tooltip-container d-flex align-center"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @focus="handleMouseEnter"
      @blur="handleMouseLeave">
    <span>{{ value }}</span>

    <button
      ref="tooltipBtn"
      class="tooltip-wrapper"
      aria-label="Show tooltip"
      type="button"
    >
      <v-icon small color="primary" class="ml-1">mdi-alert-circle-outline</v-icon>

      <div
        v-if="show"
        class="custom-tooltip"
        :class="{ 'tooltip-top': positionAbove }"
      >
        {{ description }}
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "TooltipInformation",
  props: {
    value: { type: [String, Number], required: true },
    description: { type: String, required: true }
  },
  data() {
    return {
      show: false,
      positionAbove: false
    };
  },
  methods: {
    handleMouseEnter() {
      this.show = true;

      this.$nextTick(() => {
        const el = this.$refs.tooltipBtn;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.bottom;

        this.positionAbove = spaceBelow < 200;
      });
    },
    handleMouseLeave() {
      this.show = false;
    }
  }
};
</script>

<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

@keyframes borderPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(55, 133, 149, 0.4);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(55, 133, 149, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(55, 133, 149, 0);
  }
}

.custom-tooltip {
  position: absolute;
  top: 28px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;

  background-color: white;
  color: #333;
  border: 2px solid #378595;
  border-bottom-width: 6px;
  padding: 8px 12px;
  border-radius: 10px;

  width: max-content;
  max-width: 620px;
  min-width: 120px;

  max-height: 150px;
  overflow: auto;

  font-size: 14px;
  text-align: left;
  white-space: normal;
  word-break: break-word;

  animation: borderPulse 2s ease-out infinite;
}


.tooltip-top {
  top: auto;
  bottom: 28px;
}
</style>